import { Component } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams, IDoesFilterPassParams } from 'ag-grid-community';
import { CustomFilterService } from 'src/app/services/custom-filter.service';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'custom-complete-incomplete-notstarted-filter',
  template: `
    <div class="padding-10" fxLayout="column" fxFlex>
      <mat-checkbox color="primary" class="padding-5" [(ngModel)]="completeSelected" (change)="selectionChanged()">
        {{ 'REPORTDATA.complete' | translate }}
      </mat-checkbox>

      <mat-checkbox color="primary" class="padding-5" [(ngModel)]="incompleteSelected" (change)="selectionChanged()">
        {{ 'REPORTDATA.incomplete' | translate }}
      </mat-checkbox>

      <mat-checkbox color="primary" class="padding-5" [(ngModel)]="notStartedSelected" (change)="selectionChanged()">
        {{ 'REPORTDATA.notStarted' | translate }}
      </mat-checkbox>

      <mat-checkbox color="primary" class="padding-5" [(ngModel)]="notApplicableSelected" (change)="selectionChanged()">
        {{ 'REPORTDATA.na' | translate }}
      </mat-checkbox>
    </div>
  `,
  styles: [
    `
      :host ::ng-deep label.mat-checkbox-layout {
        width: 100%;
      }
      :host ::ng-deep label .mat-checkbox-inner-container {
        margin-left: 0px;
      }
    `,
  ],
})
export class CustomCompleteIncompleteNotstartedRatingFilterComponent implements IFilterAngularComp {
  private params: IFilterParams;
  completeSelected: boolean = true;
  incompleteSelected: boolean = true;
  notStartedSelected: boolean = true;
  notApplicableSelected: boolean = true;

  constructor(private cService: CommonService, private customFilterService: CustomFilterService) {}

  agInit(params: IFilterParams) {
    this.params = params;
  }

  isFilterActive(): boolean {
    return (
      !this.completeSelected || !this.incompleteSelected || !this.notStartedSelected || !this.notApplicableSelected
    );
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    let filterExpression: boolean;
    const cellValue = this.customFilterService.getCellValue(this.params, params);
    const rating = this.cService.completeIncompleteNotStartedNa;

    // Single de-selections
    if (!this.notStartedSelected) {
      filterExpression = cellValue < rating.notStarted;
    }

    if (!this.incompleteSelected) {
      filterExpression = cellValue != rating.incomplete;
    }

    if (!this.completeSelected) {
      filterExpression = cellValue != rating.complete;
    }

    if (!this.notApplicableSelected) {
      filterExpression = cellValue >= rating.complete;
    }

    // Double de-selections
    if (!this.notStartedSelected && !this.incompleteSelected) {
      filterExpression = cellValue <= rating.complete;
    }

    if (!this.notStartedSelected && !this.completeSelected) {
      filterExpression = cellValue == rating.incomplete || cellValue < rating.complete; // <-- Captures NA
    }

    if (!this.notStartedSelected && !this.notApplicableSelected) {
      filterExpression = cellValue == rating.incomplete || cellValue == rating.complete;
    }

    if (!this.incompleteSelected && !this.completeSelected) {
      filterExpression = cellValue == rating.notStarted || cellValue < rating.complete; // <-- Less than low = NA
    }

    if (!this.incompleteSelected && !this.notApplicableSelected) {
      filterExpression = cellValue == rating.notStarted || cellValue == rating.complete;
    }

    if (!this.completeSelected && !this.notApplicableSelected) {
      filterExpression = cellValue >= rating.incomplete;
    }

    // Triple de-selections / single selection
    if (!this.notStartedSelected && !this.incompleteSelected && !this.completeSelected) {
      // Not applicable selected
      filterExpression = cellValue < rating.complete;
    }

    if (!this.notStartedSelected && !this.incompleteSelected && !this.notApplicableSelected) {
      // Low selected
      filterExpression = cellValue == rating.complete;
    }

    if (!this.notStartedSelected && !this.completeSelected && !this.notApplicableSelected) {
      // Medium selected
      filterExpression = cellValue == rating.incomplete;
    }

    if (!this.incompleteSelected && !this.completeSelected && !this.notApplicableSelected) {
      // High selected
      filterExpression = cellValue == rating.notStarted;
    }

    // Catch all - nothing selected
    if (!this.notStartedSelected && !this.incompleteSelected && !this.completeSelected && !this.notApplicableSelected) {
      filterExpression = cellValue == null;
    }

    return filterExpression;
  }

  getModel(): any {
    return;
  }

  setModel(model: any) {}

  // ----------------------

  selectionChanged() {
    this.params.filterChangedCallback();
  }
}
